import { RecordType } from 'app/constants/GlobalTypes'

import BaseReducer from './Base'

const Document = BaseReducer<IDocument>({ recordType: RecordType.document })

export default Document
